import { Key, ReactNode } from 'react'
import { theme } from '@lmc/ui-kit'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { MenuItemType } from 'antd/lib/menu/hooks/useItems'

export type CustomMenuItemType = ItemType & {
  id?: string
  label: string
  url: string
  icon: ReactNode
  'data-intercom-target'?: string
  subItems?: ItemType & { 
    label: string
    url: string
    icon: ReactNode
    id?: string
    'data-intercom-target'?: string 
  }[]
}

type ExtendedMenuItem = MenuItemType & {
  id?: string
  key: Key
  icon?: ReactNode
  children?: ExtendedMenuItem[]
  label: ReactNode
  type?: 'group'
  'data-intercom-target'?: string
}

export const getNavigationMenuItems = (menuItems?: CustomMenuItemType[]) => {
  const getItem = (
    label: ReactNode,
    key: Key,
    icon?: ReactNode,
    children?: ExtendedMenuItem[],
    type?: 'group',
    id?: string,
    dataIntercomTarget?: string
  ): ExtendedMenuItem => {
    const menuItem = {
      key,
      icon,
      children,
      label,
      type,
    } as ExtendedMenuItem

    if (id) {
      menuItem.id = id
    }

    if (dataIntercomTarget) {
      menuItem['data-intercom-target'] = dataIntercomTarget
    }

    return menuItem
  }

  const items = menuItems?.map((item) =>
    getItem(
      item?.label,
      item?.url,
      item?.icon,
      item?.subItems?.map((subItem) =>
        getItem(
          subItem?.label,
          subItem?.url,
          undefined,
          undefined,
          undefined,
          subItem?.id,
          subItem?.['data-intercom-target']
        )
      ),
      undefined,
      item?.id,
      item?.['data-intercom-target']    
    )
  )

  return items
}

export const navigationTheme = {
  token: {
    colorPrimary: theme.palette.blue,
  },
  components: {
    Menu: {
      colorItemBgHover: '#E6F4FF',
      colorItemTextSelected: theme.color.status.primary,
      colorItemText: theme.color.neutral.color3,
    },
  },
}
